import { useMemo } from 'react';
import { COMBO_BOX_OPTIONS_3 } from '../combobox-popovers/all-filters-combobox-popover';
import PickupDateFiltersComboBoxPopover from '../combobox-popovers/pickup-date-filters-combobox-popover';
import {
  PICKUP_DATE_FILTER_OPTIONS,
  type PickupDateFilterChipProps,
  type PickupDateFiltersState,
} from '../types';
import BaseDateFilterChip from './base-date-filter-chip';

const PickupDateFilterChip = (props: PickupDateFilterChipProps) => {
  const {
    filtersState,
    setFiltersState,
    deleteFilter,
    shouldDeleteWhenNoFiltersAreSelected,
  } = props;

  const selectedOption = useMemo(() => {
    return PICKUP_DATE_FILTER_OPTIONS.find(
      (option) => option.value === filtersState.selectedFilters,
    );
  }, [filtersState.selectedFilters]);

  const useBeforeAfterCopy = useMemo(() => {
    return selectedOption?.value !== 'in-the-past';
  }, [JSON.stringify(selectedOption)]);

  return (
    // TODO: fix the type
    <BaseDateFilterChip<PickupDateFiltersState>
      filtersState={filtersState}
      setFiltersState={setFiltersState}
      FiltersComboBoxPopover={PickupDateFiltersComboBoxPopover}
      deleteFilter={deleteFilter}
      representativeIcon={
        COMBO_BOX_OPTIONS_3.find((option) => option.value === 'pickup_date')
          ?.icon
      }
      filterName="Pickup date"
      filterQuantifier={{
        singular: selectedOption?.label || '',
        plural: selectedOption?.label || '',
      }}
      shouldDeleteWhenNoFiltersAreSelected={
        shouldDeleteWhenNoFiltersAreSelected
      }
      useBeforeAfterCopy={useBeforeAfterCopy}
    />
  );
};

export default PickupDateFilterChip;
